<script setup lang="ts">
import { FetchTicketResponsePriority } from 'src/api/models';

interface Props {
  priority?: FetchTicketResponsePriority;
  size?: number;
}

const props = defineProps<Props>();

const getSeverityIcon = (priority: FetchTicketResponsePriority) => {
  switch (priority) {
    case FetchTicketResponsePriority.high:
      return 'pi-angle-double-up';
    case FetchTicketResponsePriority.medium:
      return 'pi-angle-up';
    case FetchTicketResponsePriority.lows:
      return 'pi-angle-down';
    default:
      return '';
  }
};

const getSeverityColorClass = (priority: FetchTicketResponsePriority) => {
  switch (priority) {
    case FetchTicketResponsePriority.high:
      return 'text-red-500';
    case FetchTicketResponsePriority.medium:
      return 'text-yellow-500';
    case FetchTicketResponsePriority.lows:
      return 'text-blue-500';
    default:
      return '';
  }
};

</script>

<template>
  <i
    v-if="priority && getSeverityIcon(priority)"
    v-tooltip="priority"
    class="pi"
    :class="[getSeverityIcon(priority), getSeverityColorClass(priority)]"
    :style="{ fontSize: (size || 14) + 'px' }"
  />
</template>
